const ALLOWED_STATES = new Set([
  'recording',
  'finalizing',
  'ready',
  'error'
]);

export function createRecordingManifest(metadata = {}, createdAt = Date.now()) {
  if (!metadata.recordingId) throw new TypeError('recordingId is required');
  if (!metadata.fileName) throw new TypeError('fileName is required');

  return {
    version: 2,
    recordingId: metadata.recordingId,
    fileName: metadata.fileName,
    matchId: metadata.matchId ?? null,
    teams: metadata.teams ?? null,
    mimeType: metadata.mimeType || 'video/webm',
    writerKind: metadata.writerKind || 'unknown',
    qualificationMirror: metadata.qualificationMirror === true,
    fallbackReason: metadata.fallbackReason || null,
    createdAt,
    lastChunkAt: null,
    bytes: 0,
    chunks: 0,
    state: 'recording'
  };
}

export function advanceRecordingManifest(manifest, {
  chunkBytes,
  healthEvidence,
  at = Date.now()
} = {}) {
  if (manifest?.state !== 'recording') {
    throw new Error('Recording manifest is not recording');
  }
  const bytes = Number(chunkBytes);
  if (!Number.isFinite(bytes) || bytes < 0) {
    throw new TypeError('chunkBytes must be a non-negative number');
  }

  return {
    ...manifest,
    lastChunkAt: at,
    bytes: (Number(manifest.bytes) || 0) + bytes,
    chunks: (Number(manifest.chunks) || 0) + 1,
    ...(healthEvidence && typeof healthEvidence === 'object' ? { healthEvidence } : {}),
    state: 'recording'
  };
}

export function transitionRecordingManifest(manifest, state, patch = {}) {
  if (!ALLOWED_STATES.has(state)) {
    throw new TypeError(`Unsupported recording manifest state: ${state}`);
  }
  return { ...manifest, ...patch, state };
}
